


import wrapperCss from "@src/assets/_libs/layout/_l-wrapper.module.scss"
import footerCss from "@src/assets/_libs/layout/_l-footer.module.scss"
import mContactCss from "@src/assets/_libs/module/_m-contact.module.scss"

// import {
//   anchorPictureType,
//   PictureLink,
// } from "@src/components/atoms/Link/PictureLink";
// import {
//   FooterLinkList,
//   footerLinkListType,
// } from "@src/components/molecules/FooterLinkList";

// export type footerType = {
//   anchorPicture: anchorPictureType;
//   footerLinkList: footerLinkListType;
// };

/**
 * フッター用organism
 * @param {footerType} footer
 * @returns {JSX.Element}
 */
export function Footer(footer) {
  return (
    <footer className={`${wrapperCss["l-wrapper"]} ${footerCss["l-global-footer"]}`}>
      <div className={mContactCss["m-contact-bloc"]}>
        <p className={mContactCss["m-contact-bloc-title"] + ' ' + 'chukai-inquiry_title'}>コンタクトセンターへのお問合わせ</p>
        <div className={mContactCss["m-contact-bloc-contents"]}>
          <p className={mContactCss["m-contact-bloc-tel"]}>
            <a href="tel:0120-010101" className="js-skip-alert">
              <img src={"/img/logo_freedial.png"} alt="無料電話" width="41" className="chukai-freedial_logo_flag" />
              <span className="chukai-contact_tel">0120-010101</span>
            </a>
          </p>
          <div className="">
            <p><strong>受付時間</strong><small className="chukai-contact_time">平日 8:00～18:00<br />（土・日・祝日・年末年始を除く）</small></p>
            <p className={`${mContactCss["m-kome"]} m-kome chukai-contact_notice`}>
            </p>
          </div>

        </div>
      </div>



      <p className={footerCss["l-footer-reg"]}>
        <small>
          商号等： 大和証券株式会社 金融商品取引業者 <br className="nopc" />関東財務局長（金商）第108号<br />
          所属銀行： 株式会社大和ネクスト銀行<br />
          銀行代理業者： 大和証券株式会社 許可番号 <br className="nopc" />関東財務局長（銀代）第145号
        </small>
      </p>
      <p className="l-footer-copyright">©Daiwa Securities Co.Ltd.</p>
    </footer>
  );
}
